import { render, staticRenderFns } from "./SupportWidget.vue?vue&type=template&id=9598ffe6"
import script from "./SupportWidget.vue?vue&type=script&lang=js"
export * from "./SupportWidget.vue?vue&type=script&lang=js"
import style0 from "./SupportWidget.vue?vue&type=style&index=0&id=9598ffe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports